

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    multipleLocationDistance: null

}


export const getDistanceBetweenTwoTown = createAsyncThunk("distance/getDistanceBetweenTwoTown", async(list,thunkApi)=> {
    try {
        const params = list.map(item => `TownIds=${item.TownIds}`).join('&&')
        const { data } = await axiosInstance.get(`/Distance/GetDistanceBetweenTowns?${params}`);
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
 
const distanceSlice = createSlice({
    name: "distance",
    initialState,
    reducers: {


    },
    extraReducers:(builder)=> {
        builder

        // get default maliyet hesabi
        .addCase(getDistanceBetweenTwoTown.pending, (state)=> {
        })

        .addCase(getDistanceBetweenTwoTown.fulfilled, (state, action)=> {
            state.multipleLocationDistance = action.payload.distance
        })

        .addCase(getDistanceBetweenTwoTown.rejected, (state, action)=> {
        })
   
    }
})


export const {} = distanceSlice.actions
export default distanceSlice.reducer
